const getVariantText = variantOptions => {
  if (!variantOptions) return ''

  return Object.values(variantOptions).filter(Boolean).join(' ')
}

export const getItemLabel = item => {
  const variantText = getVariantText(item.variant?.options)

  if (!variantText) return item.product?.name

  return `${item.product?.name} - ${variantText}`
}
